<div class="course-header">
  <div class="rightheader">
    <div class="header-title">
      <div class="header-logo">
        <img src="../../../assets/images/sidebar-logo.png" alt="CISSP" />
      </div>
      <div class="page-Title">
        <p class="HeaderUser"><span>Courses</span></p>
      </div>
    </div>
    <div class="userProfile">
      <span class="menu-spacer"></span>
      <div class="headeroption"></div>
      <div class="headerprofile">
        <div class="username">
          <p><span>Welcome,</span>{{ name }}</p>
        </div>
        <div class="userimage">
          <img
            [src]="imgurl"
            id="UserImage"
            onError="this.src='assets/user.png' "
          />
        </div>
        <div class="more-option">
          <div class="options" (click)="logout()">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 489.9 489.9"
              style="enable-background: new 0 0 489.9 489.9; fill: #8d84d1"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M468.3,255.8c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.4,0.6-0.7,0.8-1.1c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.4,0.5-0.8,0.7-1.2
                                        c0-0.1,0.1-0.2,0.1-0.2c0.2-0.4,0.4-0.8,0.6-1.3c0-0.1,0-0.1,0.1-0.2c0.2-0.4,0.3-0.9,0.5-1.4c0-0.1,0-0.2,0.1-0.2
                                        c0.1-0.5,0.3-0.9,0.3-1.4c0-0.2,0-0.3,0.1-0.5c0.1-0.4,0.1-0.8,0.2-1.2c0.1-0.6,0.1-1.1,0.1-1.7c0-0.6,0-1.1-0.1-1.7
                                        c0-0.4-0.1-0.8-0.2-1.2c0-0.2,0-0.3-0.1-0.5c-0.1-0.5-0.2-0.9-0.3-1.4c0-0.1,0-0.2-0.1-0.2c-0.1-0.5-0.3-0.9-0.5-1.4
                                        c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.4-0.9-0.6-1.3c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.4-0.4-0.8-0.7-1.2c-0.1-0.1-0.1-0.2-0.2-0.3
                                        c-0.3-0.4-0.5-0.8-0.8-1.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.4-0.4-0.7-0.9-1.2-1.3l-98.9-98.8c-6.7-6.7-17.6-6.7-24.3,0
                                        c-6.7,6.7-6.7,17.6,0,24.3l69.6,69.6H136.8c-9.5,0-17.2,7.7-17.2,17.1c0,9.5,7.7,17.2,17.2,17.2h276.8l-69.1,69.1
                                        c-6.7,6.7-6.7,17.6,0,24.3c3.3,3.3,7.7,5,12.1,5s8.8-1.7,12.1-5l98.3-98.3C467.5,256.6,467.9,256.2,468.3,255.8z"
                />
                <path
                  d="M110.7,34.3h128c9.5,0,17.2-7.7,17.2-17.1c0-9.5-7.7-17.2-17.2-17.2h-128C59.4,0,17.6,41.8,17.6,93.1v303.7
                                        c0,51.3,41.8,93.1,93.1,93.1h125.9c9.5,0,17.2-7.7,17.2-17.1c0-9.5-7.7-17.2-17.2-17.2H110.7c-32.4,0-58.8-26.4-58.8-58.8V93.1
                                        C52,60.6,78.3,34.3,110.7,34.3z"
                />
              </g>
            </svg>
            <span>Logout</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="pc-tab" *ngIf="!noFound">
  <input checked="checked" id="tab1" type="radio" name="pct" />
  <input id="tab2" type="radio" name="pct" />
  <section>
    <div class="tab1">
      <div class="tab-titles" *ngIf="courselist.length > 0">
        <h3>Enrolled Courses</h3>
      </div>
      <div class="select-course-wrapper Enrolled-Courses">
        <div class="select-course-box" *ngFor="let item of courselist">
          <div (click)="CertificationClick(item)">
            <div class="select-course-box-image">
              <img
                [src]="item.img_path"
                onError="this.src='assets/images/1.png'"
              />
            </div>
            <div class="select-course-content">
              <div class="select-course-content-top">
                <p class="cissp-box">
                  <span title="{{ item.short_name }}">{{
                    item.short_name
                  }}</span>
                </p>
                <p>{{ item.cohort_name }}<span></span></p>
              </div>
              <div class="select-course-content-bottom">
                <p *ngIf="item.percentage < 100">
                  Course Duration <span>{{ item.day }} Days</span>
                </p>
                <p *ngIf="item.percentage == 100">
                  <svg
                    style="height: 22px; width: 101px"
                    width="101"
                    height="22"
                    viewBox="0 0 101 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M34.544 16.112C33.5827 16.112 32.7427 15.9067 32.024 15.496C31.3147 15.076 30.7687 14.4833 30.386 13.718C30.0033 12.9527 29.812 12.0473 29.812 11.002C29.812 9.966 30.0033 9.06533 30.386 8.3C30.7687 7.53467 31.3147 6.94667 32.024 6.536C32.7427 6.12533 33.5827 5.92 34.544 5.92C35.2253 5.92 35.8553 6.02733 36.434 6.242C37.022 6.44733 37.5167 6.75067 37.918 7.152L37.414 8.216C36.9473 7.83333 36.4853 7.558 36.028 7.39C35.58 7.21267 35.09 7.124 34.558 7.124C33.522 7.124 32.7193 7.46 32.15 8.132C31.59 8.804 31.31 9.76067 31.31 11.002C31.31 12.2527 31.59 13.2187 32.15 13.9C32.7193 14.572 33.522 14.908 34.558 14.908C35.09 14.908 35.58 14.824 36.028 14.656C36.4853 14.4787 36.9473 14.1987 37.414 13.816L37.918 14.88C37.5167 15.2813 37.022 15.5893 36.434 15.804C35.8553 16.0093 35.2253 16.112 34.544 16.112ZM42.5076 16.098C41.8169 16.098 41.2103 15.9487 40.6876 15.65C40.1649 15.3513 39.7589 14.9267 39.4696 14.376C39.1896 13.8253 39.0496 13.1813 39.0496 12.444C39.0496 11.7067 39.1896 11.0627 39.4696 10.512C39.7589 9.952 40.1649 9.52267 40.6876 9.224C41.2103 8.92533 41.8169 8.776 42.5076 8.776C43.1889 8.776 43.7909 8.92533 44.3136 9.224C44.8363 9.52267 45.2376 9.952 45.5176 10.512C45.8069 11.0627 45.9516 11.7067 45.9516 12.444C45.9516 13.1813 45.8069 13.8253 45.5176 14.376C45.2376 14.9267 44.8363 15.3513 44.3136 15.65C43.7909 15.9487 43.1889 16.098 42.5076 16.098ZM42.4936 14.978C43.1469 14.978 43.6463 14.7633 43.9916 14.334C44.3369 13.9047 44.5096 13.2747 44.5096 12.444C44.5096 11.632 44.3323 11.0067 43.9776 10.568C43.6323 10.1293 43.1423 9.91 42.5076 9.91C41.8636 9.91 41.3643 10.1293 41.0096 10.568C40.6549 11.0067 40.4776 11.632 40.4776 12.444C40.4776 13.2747 40.6503 13.9047 40.9956 14.334C41.3503 14.7633 41.8496 14.978 42.4936 14.978ZM55.6544 8.776C57.2224 8.776 58.0064 9.71867 58.0064 11.604V16H56.5924V11.674C56.5924 11.0673 56.485 10.624 56.2704 10.344C56.065 10.064 55.729 9.924 55.2624 9.924C54.721 9.924 54.2917 10.1107 53.9744 10.484C53.6664 10.8573 53.5124 11.366 53.5124 12.01V16H52.0984V11.674C52.0984 11.0673 51.991 10.624 51.7764 10.344C51.571 10.064 51.235 9.924 50.7684 9.924C50.227 9.924 49.7977 10.1107 49.4804 10.484C49.163 10.8573 49.0044 11.366 49.0044 12.01V16H47.6044V10.932C47.6044 10.1947 47.567 9.532 47.4924 8.944H48.8084L48.9344 10.12C49.1397 9.69067 49.4337 9.35933 49.8164 9.126C50.199 8.89267 50.647 8.776 51.1604 8.776C52.2524 8.776 52.9664 9.22867 53.3024 10.134C53.517 9.714 53.8297 9.38267 54.2404 9.14C54.6604 8.89733 55.1317 8.776 55.6544 8.776ZM63.7701 8.776C64.3768 8.776 64.9181 8.93 65.3941 9.238C65.8701 9.546 66.2388 9.98 66.5001 10.54C66.7708 11.1 66.9061 11.744 66.9061 12.472C66.9061 13.2 66.7754 13.8393 66.5141 14.39C66.2528 14.9313 65.8841 15.3513 65.4081 15.65C64.9321 15.9487 64.3861 16.098 63.7701 16.098C63.2288 16.098 62.7528 15.986 62.3421 15.762C61.9408 15.5287 61.6374 15.1973 61.4321 14.768V19.024H60.0321V10.932C60.0321 10.1947 59.9948 9.532 59.9201 8.944H61.2361L61.3761 10.246C61.5628 9.77933 61.8661 9.42 62.2861 9.168C62.7061 8.90667 63.2008 8.776 63.7701 8.776ZM63.4481 14.978C64.0828 14.978 64.5774 14.7587 64.9321 14.32C65.2868 13.8813 65.4641 13.2653 65.4641 12.472C65.4641 11.6693 65.2868 11.044 64.9321 10.596C64.5774 10.1387 64.0828 9.91 63.4481 9.91C62.7948 9.91 62.2954 10.1293 61.9501 10.568C61.6048 11.0067 61.4321 11.632 61.4321 12.444C61.4321 13.256 61.6048 13.8813 61.9501 14.32C62.3048 14.7587 62.8041 14.978 63.4481 14.978ZM68.5633 5.696H69.9633V16H68.5633V5.696ZM78.056 12.5H73.016C73.0627 14.152 73.814 14.978 75.27 14.978C76.082 14.978 76.824 14.712 77.496 14.18L77.93 15.188C77.6127 15.468 77.2067 15.692 76.712 15.86C76.2267 16.0187 75.7367 16.098 75.242 16.098C74.1127 16.098 73.226 15.776 72.582 15.132C71.938 14.4787 71.616 13.5873 71.616 12.458C71.616 11.7393 71.756 11.1 72.036 10.54C72.3253 9.98 72.7267 9.546 73.24 9.238C73.7533 8.93 74.3367 8.776 74.99 8.776C75.942 8.776 76.6887 9.084 77.23 9.7C77.7807 10.316 78.056 11.17 78.056 12.262V12.5ZM75.018 9.826C74.486 9.826 74.052 9.98467 73.716 10.302C73.38 10.6193 73.1653 11.072 73.072 11.66H76.81C76.754 11.0627 76.572 10.61 76.264 10.302C75.956 9.98467 75.5407 9.826 75.018 9.826ZM81.4442 10.036V13.578C81.4442 14.0633 81.5469 14.4087 81.7522 14.614C81.9669 14.81 82.2609 14.908 82.6342 14.908C82.8769 14.908 83.1242 14.8707 83.3762 14.796V15.944C83.0682 16.0467 82.7182 16.098 82.3262 16.098C81.5982 16.098 81.0336 15.8927 80.6322 15.482C80.2309 15.0713 80.0302 14.474 80.0302 13.69V10.036H78.6582V8.944H80.0302V7.18L81.4442 6.69V8.944H83.3902V10.036H81.4442ZM90.7162 12.5H85.6762C85.7228 14.152 86.4742 14.978 87.9302 14.978C88.7422 14.978 89.4842 14.712 90.1562 14.18L90.5902 15.188C90.2728 15.468 89.8668 15.692 89.3722 15.86C88.8868 16.0187 88.3968 16.098 87.9022 16.098C86.7728 16.098 85.8862 15.776 85.2422 15.132C84.5982 14.4787 84.2762 13.5873 84.2762 12.458C84.2762 11.7393 84.4162 11.1 84.6962 10.54C84.9855 9.98 85.3868 9.546 85.9002 9.238C86.4135 8.93 86.9968 8.776 87.6502 8.776C88.6022 8.776 89.3488 9.084 89.8902 9.7C90.4408 10.316 90.7162 11.17 90.7162 12.262V12.5ZM87.6782 9.826C87.1462 9.826 86.7122 9.98467 86.3762 10.302C86.0402 10.6193 85.8255 11.072 85.7322 11.66H89.4702C89.4142 11.0627 89.2322 10.61 88.9242 10.302C88.6162 9.98467 88.2008 9.826 87.6782 9.826ZM98.7927 5.696V16H97.3927V14.796C97.1874 15.216 96.8794 15.538 96.4687 15.762C96.0674 15.986 95.5961 16.098 95.0547 16.098C94.4481 16.098 93.9067 15.944 93.4307 15.636C92.9547 15.328 92.5814 14.8987 92.3107 14.348C92.0494 13.788 91.9187 13.144 91.9187 12.416C91.9187 11.688 92.0494 11.0487 92.3107 10.498C92.5721 9.94733 92.9361 9.52267 93.4027 9.224C93.8787 8.92533 94.4294 8.776 95.0547 8.776C95.5867 8.776 96.0534 8.888 96.4547 9.112C96.8654 9.336 97.1734 9.65333 97.3787 10.064V5.696H98.7927ZM95.3767 14.978C96.0207 14.978 96.5154 14.7587 96.8607 14.32C97.2154 13.872 97.3927 13.2467 97.3927 12.444C97.3927 11.6413 97.2154 11.0207 96.8607 10.582C96.5154 10.134 96.0254 9.91 95.3907 9.91C94.7467 9.91 94.2427 10.1293 93.8787 10.568C93.5241 11.0067 93.3467 11.6227 93.3467 12.416C93.3467 13.2187 93.5241 13.8487 93.8787 14.306C94.2427 14.754 94.7421 14.978 95.3767 14.978Z"
                      fill="#F473B9"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.2 0C4.5667 0 0 4.5667 0 10.2C0 15.8333 4.5667 20.4 10.2 20.4C15.8333 20.4 20.4 15.8333 20.4 10.2C20.4 4.5667 15.8333 0 10.2 0ZM10.2 1.4C15.0601 1.4 19 5.33989 19 10.2C19 15.0601 15.0601 19 10.2 19C5.33989 19 1.4 15.0601 1.4 10.2C1.4 5.33989 5.33989 1.4 10.2 1.4ZM14.812 7.09872C14.5022 6.86744 14.0636 6.93109 13.8323 7.24088L9.50291 12.2316L7.01243 10.225L6.92567 10.1512C6.65212 9.9544 6.26851 9.979 6.02248 10.225C5.74911 10.4984 5.74911 10.9416 6.02248 11.215L9.0859 13.7942L9.16517 13.8626C9.46903 14.0877 9.90786 14.0313 10.1418 13.718L14.9541 8.07841L15.0099 7.99098C15.1718 7.69058 15.0936 7.30897 14.812 7.09872Z"
                      fill="url(#paint0_linear)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear"
                        x1="20.4"
                        y1="0"
                        x2="0"
                        y2="0"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#F473B9" />
                        <stop offset="1" stop-color="#F63CB2" />
                      </linearGradient>
                    </defs>
                  </svg>
                </p>
                <div class="svgheight">
                  <svg
                    viewBox="0 0 40 40"
                    id="total-pros"
                    style="width: 100% !important; height: 100% !important"
                  >
                    <circle
                      cx="20"
                      cy="20"
                      r="15.9"
                      stroke-dasharray="100 0"
                      stroke-offset="50"
                      stroke-width="3"
                    ></circle>
                    <circle
                      cx="20"
                      cy="20"
                      r="15.9"
                      attr.stroke-dasharray="{{ item.percentage }},{{
                        100 - item.percentage
                      }}"
                      stroke-width="3"
                    ></circle>
                  </svg>
                  <div class="centerper">
                    {{ item.percentage ? item.percentage : '0' }} %
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="main-empty" *ngIf="noFound">
  <div class="empty-course">
    <div class="empty-contain">
      <img src="../../assets/emptycourse.png" alt="" />
      <h3>Weird! No courses have been assigned to you.</h3>
      <span>Please contact us at <a href="/">support&#64;destcert.com</a></span>
    </div>
  </div>
  <div class="courner-img">
    <img src="../../../assets/emptypng.png" alt="" />
  </div>
</div>
<div class="reset-result" *ngIf="CourseSelectionPagePopup">
  <div class="result-body">
    <div class="containt">
      <h4>
        Would you like to be taken directly to your course dashboard for this
        course the next time you log in?
      </h4>
      <p>You can skip this course selection page</p>
      <div class="reset-btns">
        <button (click)="CourseSelectionFunc('No')">No</button>
        <button (click)="CourseSelectionFunc('Yes')">Yes</button>
      </div>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="#00041aa6"
  size="default"
  color="##d7779b"
  template="<img src='../../../assets/images/loading.gif' class='loading-indicator'/>"
  [fullScreen]="true"
>
</ngx-spinner>
